import { render, staticRenderFns } from "./order-flow.vue?vue&type=template&id=1a60a416"
import script from "./order-flow.vue?vue&type=script&lang=js"
export * from "./order-flow.vue?vue&type=script&lang=js"
import style0 from "./order-flow.vue?vue&type=style&index=0&id=1a60a416&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports